import { downloadParticipantsApi } from '../model/downloadsParticipantsApi';
import { IDownloadParticipants } from '../types';

const getDownloadParticipantsApi = downloadParticipantsApi.injectEndpoints({
  endpoints: (builder) => ({
    getDownloadsParticipants: builder.mutation<IDownloadParticipants, any>({
      query: ({ upload_type, size, page }) => {
        const sizeParams = size ? `&size=${size}` : '';
        const pageParams = page ? `page=${page}` : '';
        return {
          url: `/promo-b2b/admin/promo-b2b/admin/uploads/${upload_type}?${pageParams}${sizeParams}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetDownloadsParticipantsMutation } = getDownloadParticipantsApi;
